import { store } from "../store";

export function getAuthToken() {
  const token = localStorage.getItem("token");
  return token;
}

// Get user data from Redux store
function getUserFromStore() {
  const state = store.getState();
  return state.auth.user;
}

export function getUserRole() {
  const user = getUserFromStore();
  return user?.user_role || null;
}

export function getUserName() {
  const user = getUserFromStore();
  return user?.user_name || null;
}

export function getConnectedAccount() {
  const user = getUserFromStore();
  return user?.stripe_connected_account || null;
}

export function getCpaStatus() {
  const user = getUserFromStore();
  return user?.account_status || null;
}

export function tokenLoader() {
  const user = getUserFromStore();
  const values = {
    token: getAuthToken(),
    role: user?.user_role || null,
    name: user?.user_name || null,
    cpa_status: user?.account_status || null,
    connected_account: user?.stripe_connected_account || null,
  };
  return values;
}
